module.exports = __webpack_public_path__ + "static/media/ASU.d9c9831e.png";